<div *ngIf="showBanner" class="safari-browser">Safari unsupported. Use Chrome</div>
<div [ngStyle]="{ '--wipe-duration': wipeDuration + 'ms' }" *ngIf="wiperVisible$ | async">
  <div [ngClass]="screenWipeStatus$ | async"></div>
</div>
<div class="root-container display-flex flex-column">
  <button
    mat-mini-fab
    class="sidebar-toggle"
    [ngClass]="{ 'hide-button': !(isSidePanelExpanded$ | async) }"
    (click)="toggleSidePanel()"
    *ngIf="displayNavigation"
  >
    <div class="display-flex justify-content-end align-items-center">
      <app-icon
        [iconColor]="EColorPalette.cGray5"
        [iconHeight]="10"
        [iconWidth]="5"
        [svg]="(isSidePanelExpanded$ | async) ? EIcon.ANGLE_LEFT : EIcon.ANGLE_RIGHT"
      ></app-icon>
    </div>
  </button>
  <div class="container display-flex">
    <div
      class="sidebar-container display-flex"
      [ngClass]="[(isSidePanelExpanded$ | async) ? '' : 'hide-panel', displayNavigation ? '' : 'display-none']"
    >
      <app-side-panel
        [isSidePanelExpanded]="isSidePanelExpanded$ | async"
        (mainPageActionEvent)="mainPageActions($event)"
      ></app-side-panel>
    </div>
    <div class="app-container display-flex flex-column w-100">
      <app-top-panel
        [isSidePanelExpanded]="isSidePanelExpanded$ | async"
        (mainPageActionEvent)="mainPageActions($event)"
        [ngClass]="[displayNavigation ? '' : 'display-none']"
      ></app-top-panel>
      <div class="app-content h-100">
        <router-outlet></router-outlet>
      </div>
      <footer class="app-footer text-centered" [ngClass]="[displayNavigation ? '' : 'display-none']">
        <div class="footer-content display-flex justify-content-center align-items-center w-100">
          <div class="display-flex justify-content-center w-100">
            <sup class="trade-mark">©</sup>
            <div>
              PropUp, Inc. v<a href="https://stonly.com/kb/guide/en/release-notes-g7O3FPYxYJ/Steps/" target="_blank"
                ><span>{{ currentVersion }}</span
                >&nbsp;<span *ngIf="showBuildTime"
                  >, {{ currentVersionTimeStamp | date: 'MMM dd, YYYY HH:mm' }}</span
                ></a
              >
            </div>

            <div class="display-flex justify-content-end grid-gap-5 contact-section">
              <a href="mailto:suggestions@gopropup.com" [matTooltip]="'Suggestions?'">
                <app-icon
                  [iconColor]="EColorPalette.cYellow"
                  [iconHeight]="14"
                  [iconWidth]="14"
                  [svg]="EIcon.BULB"
                ></app-icon>
              </a>
              <a href="mailto:bugs@gopropup.com" [matTooltip]="'Report bug'">
                <app-icon [iconHeight]="14" [iconWidth]="14" [svg]="EIcon.BUG"></app-icon>
              </a>
              <a href="mailto:support@gopropup.com" [matTooltip]="'Email support'">
                <app-icon [iconHeight]="14" [iconWidth]="14" [svg]="EIcon.SUPPORT"></app-icon>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</div>
<!--disable automatic logout, at Chris's request-->
<!--<app-idle-time (logOutEvent)="mainPageActions(MainPageActions.LOGOUT)"></app-idle-time>-->

<ng-template #spinner>
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
